<template>
  <div class="nav">
    <div class="top-item" @click="handleClick(0)">
        <img
          :class="navIndex === 0 || navIndex % 2 === 1?'norm': 'innorm'"
          src="@/assets/reservation/nav_top.png"
          alt=""
        />
    </div>
    <div
      class="nav-item"
      v-for="(item, index) in nav"
      :key="index"
      @click="handleClick(index + 1)"
    >
      <div :class="navIndex === index + 1?'active-point':'point'">
        <img
          class="pointer"
          src="@/assets/reservation/nav_arrow.png"
          v-if="navIndex === index + 1"
          alt=""
        />
        <img
         class="num" :class="navIndex > index + 1?'': 'below'"
          :src="navIndex === index + 1?item.activeImg:item.inactiveImg"
          alt=""
        />
      </div>
      <div :class="navIndex === index + 1 ? 'title-active' : 'title'" v-html="item.title"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Nav",
  data() {
    return {
      nav: [
        {
          activeImg: require('@/assets/reservation/p2nav1-h_3466ae7.png'),
          inactiveImg: require('@/assets/reservation/p2nav1_a595fff.png'),
          title: "ลงทะเบียนล่วงหน้า",
        },
        {
          activeImg: require('@/assets/reservation/p2nav2-h_906b385.png'),
          inactiveImg: require('@/assets/reservation/p2nav2_07c9248.png'),
          title: "กิจกรรม<br/> ลงทะเบียนล่วงหน้า",
        },
        {
          activeImg: require('@/assets/reservation/p2nav3-h_a3ec895.png'),
          inactiveImg: require('@/assets/reservation/p2nav3_4d1a27e.png'),
          title: "เกี่ยวกับเกม",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      navIndex: (state) => state.nav.navIndex,
    }),
  },
  methods: {
    handleClick(index) {
      this.$emit("fullPageSlide", index);
    },
  },
};
</script>
<style lang="scss" scoped>
.nav {
  position: fixed;
  left: 67px;
  top: 210px;
  // transform: translateY(-50%);
  z-index: 999;
  font-size: 20px;
    @media only screen and (max-width: 768px) {
      display: none;
    }
  .top-item {
    margin-bottom: 40px;
    cursor: pointer;
    position: relative;
    text-align: left;
    // .norm {
    //   margin-left: -43px;
    // }
    // .innorm {
    //   margin-left: -260px;
    // }
  }
  &-item {
    display: flex;
    grid-gap: 15px;
    margin-bottom: 50px;
    align-items: center;
    margin-left: 43px;
    .point {
      width: 59px;
      height: 59px;
      .num {
        width: 100%;
        height: 100%;
        // margin-top: -20%;
      }
      // .below {
      //   margin-top: -10%;
      // }
      position: relative;
    }
    .active-point {
      width: 111px;
      height: 59px;
      margin-left: -52px;
      .pointer {
        width: 52px;
        height: 20px;
        position: relative;
        top: 34%;
        margin-left: -70%;
      }
      .num {
        width: 118px;
        height: 118px;
        margin-top: -50%;
        margin-left: 20%;;
      }
      position: relative;
    }
    .title {
      color: #f7f6f6;
      // letter-spacing: 2px;
      text-align: left;
      cursor: pointer;
      &:hover {
        color: #baf5fb;
      }
    }
    .title-active {
      color: #baf5fb;
      text-align: left;
    }
  }
}
</style>
